<template>
  <div class="message-board">
    <!-- 触发按钮 -->
    <div class="trigger-btn" @click="toggleBoard">
      <div class="trigger-icon">✎</div>
      <span class="trigger-text">留言</span>
    </div>

    <!-- 留言板面板 -->
    <transition name="slide-up">
      <div class="message-panel" v-if="isOpen">
        <div class="panel-header">
          <div class="panel-dot red"></div>
          <div class="panel-dot yellow"></div>
          <div class="panel-dot green"></div>
          <span class="panel-title">在线留言</span>
          <span class="panel-close" @click="closeBoard">×</span>
        </div>
        <div class="panel-body">
          <p class="panel-tip">
            您好，我们的服务时间是早9:00-晚18:00，请您在我们的服务时间内进行咨询哦~
          </p>
          
          <div class="form-group">
            <label class="form-label"><span class="required">*</span> 公司名称：</label>
            <input 
              type="text" 
              class="form-input" 
              v-model="formData.company"
              placeholder="请输入公司名称"
            >
          </div>
          <div class="form-group">
            <label class="form-label"><span class="required">*</span> 手机号：</label>
            <input 
              type="text" 
              class="form-input" 
              v-model="formData.phone"
              placeholder="请输入手机号"
              maxlength="11"
            >
          </div>
          <div class="form-group">
            <label class="form-label"><span class="required">*</span> 诉求：</label>
            <textarea 
              class="form-textarea" 
              v-model="formData.content"
              placeholder="请详细描述您的问题..."
              rows="4"
            ></textarea>
          </div>
          
          <button class="submit-btn" @click="submitMessage" :disabled="isSubmitting">
            {{ isSubmitting ? '提交中...' : '提交留言' }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

 <script>
import { addMessage } from '@/api/login'
import { Message } from 'element-ui'

export default {
  name: 'MessageBoard',
  data () {
    return {
      isOpen: false,
      isSubmitting: false,
      formData: {
        company: '',
        phone: '',
        content: ''
      }
    }
  },
  methods: {
    // ✅ 缺失的方法
    toggleBoard () {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.resetForm()
      }
    },
    closeBoard () {
      this.isOpen = false
      this.resetForm()
    },
    resetForm () {
      this.formData = {
        company: '',
        phone: '',
        content: ''
      }
    },
    
    // ✅ 缺失的手机号验证方法
    validatePhone (phone) {
      return /^1[3-9]\d{9}$/.test(phone)
    },

    // 提交留言
    async submitMessage () {
      if (!this.formData.company.trim()) {
        alert('请输入公司名称')
        return
      }
      if (!this.formData.phone.trim()) {
        alert('请输入手机号')
        return
      }
      if (!this.validatePhone(this.formData.phone)) {
        alert('请输入正确的手机号')
        return
      }
      if (!this.formData.content.trim()) {
        alert('请输入您的诉求')
        return
      }

      this.isSubmitting = true
      try {
        const res = await addMessage({
          company: this.formData.company,
          phone: this.formData.phone,
          content: this.formData.content
        })
        
        console.log('留言提交返回：', res)
        
        if (res.code === 200) {
         alert('留言提交成功！')
          this.closeBoard()
        } else {
           alert('提交失败：' + (res.msg || '未知错误'))
        }
      } catch (error) {
        console.error('留言提交失败：', error)
      alert('网络异常，请稍后重试')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.message-board {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999;
  /* ✅ 加个宽高，不然没有实际占位 */
  width: 60px;
  height: 60px;

}

/* 触发按钮 */
.trigger-btn {
  position: fixed;
  right: 0;
  bottom: 20%;
  width: 60px;
  height: 60px;
  background: #c40000;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(196, 0, 0, 0.3);
  transition: all 0.3s;
  user-select: none;
}
.trigger-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(196, 0, 0, 0.4);
}
.trigger-btn:active {
  transform: scale(0.95);
}
.trigger-icon {
  color: #fff;
  font-size: 20px;
  line-height: 1;
}
.trigger-text {
  color: #fff;
  font-size: 10px;
  margin-top: 2px;
}

/* 留言面板 */
.message-panel {
  position: fixed;
  right: 0;
  bottom: 75px;
  width: 380px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.panel-header {
  background: #f5f5f5;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}
.panel-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.panel-dot.red { background: #ff5f57; }
.panel-dot.yellow { background: #febc2e; }
.panel-dot.green { background: #28c840; }
.panel-title {
  font-size: 14px;
  color: #333;
  margin-left: 4px;
}
.panel-close {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #999;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}
.panel-close:hover {
  color: #333;
  background: #e0e0e0;
}

.panel-body {
  text-align: left;
  padding: 20px;
}
.panel-tip {
  font-size: 13px;
  color: #c40000;
  margin-bottom: 16px;
  line-height: 1.6;
}
.form-group {
  margin-bottom: 14px;
}
.form-label {
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
  display: block;
}
.required {
  color: #c40000;
}
.form-input {
  width: 100%;
  height: 38px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.3s;
  box-sizing: border-box;
}
.form-input:focus {
  border-color: #c40000;
}
.form-textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  outline: none;
  resize: none;
  font-family: inherit;
  transition: border-color 0.3s;
  box-sizing: border-box;
}
.form-textarea:focus {
  border-color: #c40000;
}

.submit-btn {
  width: 100%;
  height: 42px;
  background: #c40000;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
  margin-top: 4px;
}
.submit-btn:hover {
  background: #a30000;
}
.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.submit-btn:active {
  transform: scale(0.98);
}

/* 动画 */
.slide-up-enter-active {
  transition: all 0.3s ease-out;
}
.slide-up-leave-active {
  transition: all 0.2s ease-in;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

@media (max-width: 768px) {
  .message-panel {
    width: 300px;
    right: -10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MessageBoard.vue